import type React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { formatPermission } from "../../../../utils/utils";
import { Permission } from "../../../../interface/types";
import useApiHook from "../../../../utils/useApi";
import { useEffect, useState } from "react";
import { PermApiResponse } from "../../../../interface/interfaces";

const PermissionsPage: React.FC = () => {
  const { data, isLoading, makeRequest } = useApiHook<PermApiResponse>(
    "/admin/system-role",
    {
      method: "get",
    }
  );

  const [allAvailablePermissions, setAllAvailablePermissions] = useState<
    Permission[]
  >([]);

  
  const rolePermissions =
    (useSelector(
      (state: RootState) => state?.merchant?.permissions
    ) as Permission[]) || [];

  useEffect(() => {
    makeRequest();
  }, []);

  useEffect(() => {
    if (data?.data?.rolePermissions) {
      setAllAvailablePermissions(data.data.rolePermissions);
    }
  }, [data]);

 
  const missingPermissions = allAvailablePermissions.filter(
    (permission) => !rolePermissions.includes(permission)
  );

  const hasFullAccess = missingPermissions.length === 0;

  if (isLoading) {
    return <div className="p-10 text-center">Loading permissions...</div>;
  }

  return (
    <section className="mx-auto p-10 grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* What you can access */}
      <div className="border rounded-lg overflow-hidden shadow-sm">
        <div className="bg-green-100 p-4 border-b">
          <h2 className="text-lg font-medium text-green-800">
            What you can access
          </h2>
        </div>
        <div className="divide-y">
          {rolePermissions.map((permission, index) => (
            <div key={index} className="p-4 hover:bg-gray-50">
              <p className="flex items-center">
                <span className="font-medium text-gray-700 mr-2">Can</span>
                <span className="text-gray-600">
                  {formatPermission(permission)}
                </span>
              </p>
            </div>
          ))}
          {rolePermissions.length === 0 && (
            <div className="p-4 text-center text-gray-500">
              No permissions granted
            </div>
          )}
        </div>
      </div>

      {/* What you can't access */}
      <div className="border rounded-lg overflow-hidden shadow-sm">
        <div className="bg-red-100 p-4 border-b">
          <h2 className="text-lg font-medium text-red-800">
            What you can't access
          </h2>
        </div>
        <div>
          {hasFullAccess ? (
            <div className="flex flex-col items-center justify-center p-10 text-center">
              <h3 className="text-xl font-medium text-gray-700 mb-2">
                You have full access!
              </h3>
              <p className="text-gray-600">
                You can access all the sections of the dashboard.
              </p>
            </div>
          ) : (
            <div className="divide-y">
              {missingPermissions.map((permission, index) => (
                <div key={index} className="p-4 hover:bg-gray-50">
                  <p className="flex items-center text-gray-500">
                    <span className="font-medium mr-2 text-sm">Can't</span>
                    <span>{formatPermission(permission)}</span>
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PermissionsPage;
